import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgImage = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M10.773 7.862a3.029 3.029 0 1 1-6.057 0 3.029 3.029 0 0 1 6.057 0m-2 0a1.029 1.029 0 1 1-2.057 0 1.029 1.029 0 0 1 2.057 0"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M3 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm18 2H3v18h1.074l11.41-11.41a2 2 0 0 1 2.829 0L21 12.277zm0 18H6.903l9.996-9.996L21 15.105z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgImage);
export default Memo;
